import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight, Bed, Bath, Car, Ruler } from "lucide-react";
import { buildOnLot, includedFeatures, floorPlans, img } from "../mock";
import Seo from "../components/Seo";

const BuildOnYourLot = () => {
  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.1 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Seo
        title="Build On Your Lot"
        description="Build a custom home on your own lot anywhere in Brevard County. Choose a Monarch floor plan or a fully custom design, with energy-efficient features and a 10-year structural warranty."
        keywords="build on your lot Brevard County, custom home builder Melbourne FL, on your lot builder Florida"
        path="/build-on-your-lot"
      />
      <section className="mh-page-hero" style={{ backgroundImage: `url(${img.ext3})` }}>
        <div className="mh-page-hero-inner">
          <div className="mh-crumb"><Link to="/">Home</Link> / Build On Your Lot</div>
          <h1>Build On Your Lot</h1>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container mh-split">
          <div className="mh-reveal">
            <img src="/images/real/mh-17.jpg" alt="A Monarch custom home exterior" />
          </div>
          <div className="mh-reveal">
            <div className="mh-eyebrow">Your Land, Your Vision</div>
            <h2>A Custom Home, Built Where You Want It</h2>
            <p>{buildOnLot.intro}</p>
            <div style={{ marginTop: 28 }}>
              <Link to="/contact" className="mh-cta-btn">Schedule A Consultation <ArrowRight size={16} /></Link>
            </div>
          </div>
        </div>
      </section>

      <section className="mh-section cream tight">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">The Process</div>
            <h2>How We Bring Your Home To Life</h2>
            <div className="mh-divider" />
          </div>
          <div className="mh-steps">
            {buildOnLot.steps.map((s, i) => (
              <div key={i} className="mh-step mh-reveal" style={{ transitionDelay: `${i * 70}ms` }}>
                <div className="mh-step-num">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Design &amp; Engineering</div>
            <h2>Every Monarch Home Includes</h2>
            <p>For the homebuyer who desires a custom home with today&rsquo;s highest standards in energy efficiency, we include many standard features that pay back the homeowner with lower energy bills - without compromising comfort.</p>
            <div className="mh-divider" />
          </div>
          <div className="mh-feature-list">
            {includedFeatures.map((f, i) => (
              <div key={i} className="mh-feature-item mh-reveal">
                <div className="mh-check"><Check size={18} /></div>
                <p>{f}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mh-section cream tight">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Our Floor Plans</div>
            <h2>Estate &amp; Cottage Series Designs</h2>
            <p>Choose from a wide range of thoughtful, innovative designs - each fully customizable to your personal taste.</p>
            <div className="mh-divider" />
          </div>
          <div className="mh-grid-3">
            {floorPlans.map((p, i) => (
              <div key={i} className="mh-home-card mh-reveal">
                <div className="mh-home-media">
                  <img src={p.image} alt={p.name} loading="lazy" />
                </div>
                <div className="mh-home-body">
                  <h3>{p.name}</h3>
                  <p className="mh-home-desc">{p.note}</p>
                  <div className="mh-specs">
                    <span className="mh-spec"><Bed size={14} /> {p.beds}</span>
                    <span className="mh-spec"><Bath size={14} /> {p.baths}</span>
                    <span className="mh-spec"><Car size={14} /> {p.garage}</span>
                    <span className="mh-spec"><Ruler size={14} /> {p.sqft} sq.ft.</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuildOnYourLot;
